import axios from '../../axios'

//查询
export const getAgentInfo = data => {
    return axios({
        url: '/api/base/aboard/agent',
        method: 'get',
        data:data.data
    })
}

//增加或编辑
export const AddOneAgentInfo = data => {
    return axios({
        url: '/api/base/aboard/agent',
        method: data.method || 'GET',
        data:data.data
    })
}

//删除
export const delOneAgentInfo = data => {
    return axios({
        url: '/api/base/aboard/agent',
        method: 'DELETE',
        data
    })
}

//获取机构介绍内容信息
export const showOneAgentInfo = data => {
    return axios({
        url: '/api/base/aboard/agent/intro',
        method: 'GET',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/adroad/agent.js